/**
 * ss-feat-grid.js — AJAX pagination via Shopify Section Rendering API
 */
(function () {
  'use strict';

  var MOBILE_MQ = '(max-width: 749px)';

  function isMobile() {
    return window.matchMedia(MOBILE_MQ).matches;
  }

  function initGrid(section) {
    if (!section || section.dataset.ssFeatInit) return;
    section.dataset.ssFeatInit = '1';

    var sectionId = section.getAttribute('data-section-id');
    var totalPages = parseInt(section.getAttribute('data-total-pages'), 10) || 1;
    var currentPage = 1;

    var grid = section.querySelector('[data-ss-feat-products]');
    var pagesWrap = section.querySelector('[data-ss-feat-pages]');
    var prevBtn = section.querySelector('[data-ss-feat-prev]');
    var nextBtn = section.querySelector('[data-ss-feat-next]');
    var currentEl = section.querySelector('[data-ss-feat-current]');

    if (!grid || totalPages <= 1) return;

    function gapEl() {
      var s = document.createElement('span');
      s.className = 'ss-feat-grid__page is-gap';
      s.textContent = '…';
      s.setAttribute('aria-hidden', 'true');
      return s;
    }

    function addPageBtn(num) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ss-feat-grid__page' + (num === currentPage ? ' is-active' : '');
      btn.textContent = String(num);
      btn.setAttribute('aria-label', 'Page ' + num);
      if (num === currentPage) btn.setAttribute('aria-current', 'page');
      btn.addEventListener('click', function () { goToPage(num); });
      pagesWrap.appendChild(btn);
    }

    function buildPageButtons() {
      if (!pagesWrap) return;
      pagesWrap.innerHTML = '';

      if (isMobile()) {
        var mobilePages = [];
        for (var p = 1; p <= Math.min(3, totalPages); p++) mobilePages.push(p);
        if (totalPages > 4) mobilePages.push('gap');
        if (totalPages > 3 && mobilePages.indexOf(totalPages) === -1) mobilePages.push(totalPages);
        if (currentPage > 3 && currentPage < totalPages && mobilePages.indexOf(currentPage) === -1) {
          if (mobilePages.indexOf('gap') === -1) mobilePages.splice(mobilePages.length - 1, 0, 'gap');
          mobilePages.splice(mobilePages.length - 1, 0, currentPage);
        }
        mobilePages.forEach(function (item) {
          if (item === 'gap') pagesWrap.appendChild(gapEl());
          else addPageBtn(item);
        });
        return;
      }

      var maxShow = 5;
      var start = Math.max(1, currentPage - 2);
      var end = Math.min(totalPages, start + maxShow - 1);
      if (end - start < maxShow - 1) start = Math.max(1, end - maxShow + 1);

      if (start > 1) {
        addPageBtn(1);
        if (start > 2) pagesWrap.appendChild(gapEl());
      }
      for (var i = start; i <= end; i++) addPageBtn(i);
      if (end < totalPages) {
        if (end < totalPages - 1) pagesWrap.appendChild(gapEl());
        addPageBtn(totalPages);
      }
    }

    function updateControls() {
      if (prevBtn) {
        prevBtn.disabled = currentPage <= 1;
        prevBtn.classList.toggle('is-disabled', currentPage <= 1);
      }
      if (nextBtn) {
        nextBtn.disabled = currentPage >= totalPages;
        nextBtn.classList.toggle('is-disabled', currentPage >= totalPages);
      }
      if (currentEl) currentEl.textContent = String(currentPage);
      buildPageButtons();
    }

    function goToPage(page) {
      if (page < 1 || page > totalPages || page === currentPage) return;
      currentPage = page;
      grid.classList.add('is-loading');

      var url = window.location.pathname + '?sections=' + encodeURIComponent(sectionId) + '&page=' + page;
      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data[sectionId];
          if (!html) throw new Error('No section HTML');
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-ss-feat-products]');
          if (newGrid && newGrid.querySelector('.ss-feat-grid__cell')) {
            grid.innerHTML = newGrid.innerHTML;
          } else if (page > 1) {
            currentPage = 1;
            return goToPage(1);
          }
          updateControls();
          grid.classList.remove('is-loading');
          var firstCell = grid.querySelector('.ss-feat-grid__cell, .ss-pcard, .grid__item');
          if (firstCell) {
            var top = firstCell.getBoundingClientRect().top + window.scrollY - 120;
            window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
          }
        })
        .catch(function () {
          grid.classList.remove('is-loading');
        });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goToPage(currentPage - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goToPage(currentPage + 1); });
    window.addEventListener('resize', buildPageButtons, { passive: true });
    updateControls();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ss-feat-grid]').forEach(initGrid);
  });
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-ss-feat-grid]').forEach(initGrid);
  });
})();
